@if (form) {
  <form (ngSubmit)="onSubmit()" [formGroup]="form" class="grid grid-cols-12 gap-2" novalidate>
    <app-form-number-input
      [form]="form"
      [min]="0"
      id="mindestAnzahl"
      label="CHOP.MINDEST_ANZAHL"></app-form-number-input>
    <app-form-number-input
      [form]="form"
      [min]="0"
      id="mindestMinutenProTag"
      label="CHOP.MINDEST_MIN_PRO_TAG"></app-form-number-input>
    <app-form-number-input
      [form]="form"
      [min]="0"
      id="mindestMinutenProDurchfuehrung"
      label="CHOP.MINDEST_MIN_PRO_DURCHFUEHRUNG"></app-form-number-input>
    <app-form-button-bar (onCancel)="cancel()" [form]="form" [saveDisabled]="submitting"></app-form-button-bar>
  </form>
}
